import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { LesseeService } from '../../services/lessee.service';
import { LesseePaymentComponent } from '../lessee-payment/lessee-payment.component';

@Component({
  selector: 'app-account-summary',
  templateUrl: './account-summary.component.html',
  styleUrls: ['./account-summary.component.scss']
})
export class AccountSummaryComponent implements OnInit {
  constructor(private lesseeService: LesseeService, public dialog: MatDialog) { }

  ngOnInit() {}
  
  getAccountSummary() {
    return this.lesseeService.getAccountSummary();
  }

  payNowAction() {
    this.lesseeService.getAccountSummary().then((res) => {
      const dialogRef = this.dialog.open(LesseePaymentComponent, {
        width: '1000px',
        maxWidth: '100vw',
        maxHeight: '100vh',
        panelClass: 'mobile-dialog-panel',
        autoFocus: false,
        data: {
          accountSummary: res
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        
      });
    });
  }
}
